<template>
  <div class="w-100 h-100 mt-1">
    <v-row>
      <!-- <v-col>
        <v-text-field
          label="Suchen"
          placeholder="Suchen"
          outlined
          append-icon="fa fa-search"
          v-model="filter.search"
          @change="changeFilter"
        ></v-text-field>
      </v-col> -->
      <v-col>
        <v-select
          label="Kategorie"
          outlined
          :items="weaponCategories"
          clearable
          v-model="filter.weaponType"
          @change="
            () => {
              changeFilter();
              fetchWeapons();
            }
          "
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          label="Waffe"
          outlined
          :items="weapons"
          item-text="name"
          clearable
          v-model="filter.weapon"
          @change="changeFilter"
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          label="Build typ"
          outlined
          :items="weaponBuildTypes"
          clearable
          v-model="filter.buildType"
          @change="changeFilter"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-container fluid style="overflow-y: auto">
        <v-skeleton-loader
          v-if="loading"
          type="list-item@4"
        ></v-skeleton-loader>
        <v-expansion-panels v-else-if="builds.length > 0">
          <WeaponBuildItem
            :weapons="weapons"
            :item="item"
            v-for="(item, i) in builds"
            :key="i"
          />
        </v-expansion-panels>
        <v-card v-else> Es wurden keine Weapon Builds gefunden </v-card>
      </v-container>
    </v-row>
  </div>
</template>

<script lang="ts">
import ApiResult from "@/shared/ApiResult";
import DFWeapon from "@/shared/DFWeapon";
import DFWeaponBuild from "@/shared/DFWeaponBuild";
import DFWeaponBuildType from "@/shared/DFWeaponBuildType";
import DFWeaponType from "@/shared/DFWeaponType";
import Vue from "vue";
import WeaponBuildItem from "./WeaponBuildItem.vue";
export default Vue.extend({
  components: { WeaponBuildItem },
  name: "WeaponBuilds",
  async mounted() {
    await Promise.all([this.fetchWeapons(), this.fetchBuilds()]);
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      weaponBuildTypes: Object.values(DFWeaponBuildType),
      weaponCategories: Object.values(DFWeaponType),
      filter: {
        weaponType: null as DFWeaponType.AssaultRifle | null,
        // search: "",
        weapon: null as DFWeapon | null,
        buildType: null as "Budget" | "High-End" | null,
      },
      weapons: [] as DFWeapon[],
      builds: [] as DFWeaponBuild[],
    };
  },
  methods: {
    changeFilter() {
      console.log("changeFilter");
      this.fetchBuilds();
    },
    async fetchWeapons() {
      this.filter.weapon = null;
      const res = await this.axios.get<ApiResult<DFWeapon[]>>("/df/weapons", {
        params: {
          weaponType: this.filter.weaponType,
        },
      });
      if (res.data.success) {
        this.weapons = res.data.data;
      }
    },
    async fetchBuilds() {
      const res = await this.axios.get<ApiResult<DFWeaponBuild[]>>(
        "/df/weaponbuilds",
        {
          params: this.filter,
        }
      );

      if (res.data.success) {
        this.builds = res.data.data;
      }
    },
  },
});
</script>
